import { Box, BoxProps, useTheme } from "@chakra-ui/react";
import React, { FC } from "react";

interface IProps extends BoxProps {
  children: React.ReactNode;
}

const ResponsiveContainer: FC<IProps> = ({
  children,
  px = { base: 4, md: 7, lg: 12 },
  mx = "auto",
}) => {
  const theme = useTheme();

  return (
    <Box
      maxW={{ base: theme.breakpoints.customLg, xl: theme.breakpoints.xl }}
      mx={mx}
      px={px}
    >
      {children}
    </Box>
  );
};

export default ResponsiveContainer;
